import {ResponseField as ResponseFieldCLass} from "./meta/ResponseField";

export function ResponseField() {
    return ResponseFieldCLass.Register();
}
